import React, { useState, useEffect } from "react";
import { makeStyles, List, Menu, MenuItem } from "@material-ui/core/";
import { useSelector, useDispatch } from "react-redux";
import MenuIcon from "@material-ui/icons/Menu";
import IconButton from "@material-ui/core/IconButton";
import { Link, withRouter } from "react-router-dom";
import NavMenuItem from "./MenuItems";
import NavItems from "./MenuData";
import { isObjectEmpty } from "../../../utils/general";
import Backdrop from "../../Backdrop";
import {
  clearErrorStatusCode,
  clearErrorMessage,
  getApplicantStatus,
  clearApplicantStatus,
} from "../../../reduxSlices/applicationSlice";
import {
  clearLoginData,
  isLoggedInUpdate,
} from "../../../reduxSlices/loginSlice";
import localizedStrings from "../../../utils/localize";

const useStyle = makeStyles((theme) => ({
  navRoot: {
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
  logoResponsive: {
    width: "100%",
    marginLeft: "0.5rem",
    [theme.breakpoints.up("md")]: {
      width: "60%",
      marginLeft: "0",
    },
  },
  navMenu: {
    display: "flex",
    alignItems: "center",
  },
  listDisplay: {
    display: "flex",
    alignItems: "center",
  },
  listItem: {
    fontSize: "1rem",
    color: "#005598",
    textDecoration: "none",
    "&:hover": {
      color: "#e02222",
    },
  },
  ListItemRoot: {
    width: "auto",
    padding: "0 0.8rem",
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    justifyContent: "flex-end",
    color: "#005598",
    width: "100%",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  contentFont: {
    fontSize: "0.92rem",
  },
}));

const NavigationMenuItem = (props) => {
  const classes = useStyle(props);
  const dispatch = useDispatch();

  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
  const [Items, setItems] = useState(NavItems);
  const [error, setError] = useState({
    isError: false,
    message: "",
    showSnackbar: false,
  });
  const [isMobile, setIsMobile] = useState(false);

  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const applicantStatus = useSelector(

    (state) => state.applicationData.applicantStatus,
  );
console.log("status",applicantStatus)
  // const clearApplicantStatus = useSelector(
  //   (state) => state.applicationData.clearApplicantStatus
  // );

  const errorMessage = useSelector(
    (state) => state.applicationData.errorMessage,
  );

  const errorStatusCode = useSelector(
    (state) => state.applicationData.errorStatusCode,
  );
  //current lagnguage
  const language = useSelector((state) => state.language.language);
  //set the current language to localize string
  localizedStrings.setLanguage(language);
  useEffect(() => {
    const newItems = [...Items];
    
    newItems[0].name =
      localizedStrings.navigation.menu.prospectiveStudents.prospectiveStudents;
    //  newItems[0].subMenuItems[0`].`name=localizedStrings.navigation.menu.prospectiveStudents.prospectiveStudents;
    newItems[0].subMenuItems[0].name =
      localizedStrings.navigation.menu.prospectiveStudents.applyToday;
    newItems[0].subMenuItems[1].name =
      localizedStrings.navigation.menu.prospectiveStudents.reqesutInfo;
    newItems[0].subMenuItems[2].name =
      localizedStrings.navigation.menu.prospectiveStudents.interviewSelection;
    newItems[1].name = localizedStrings.navigation.menu.students.students;
   newItems[1].subMenuItems[0].name =
    localizedStrings.navigation.menu.students.studentDashboard;
    newItems[1].subMenuItems[1].name =
      localizedStrings.navigation.menu.students.profile;
    newItems[1].subMenuItems[2].name =
      localizedStrings.navigation.menu.students.financialAid;
    newItems[1].subMenuItems[3].name =
      localizedStrings.navigation.menu.students.degreePlan;
    newItems[1].subMenuItems[4].name =
      localizedStrings.navigation.menu.students.classes;
    newItems[1].subMenuItems[5].name =
      localizedStrings.navigation.menu.students.schedule;
    newItems[1].subMenuItems[6].name =
      localizedStrings.navigation.menu.students.grades;
    newItems[1].subMenuItems[7].name =
      localizedStrings.navigation.menu.students.selectClasses;
    //  newItems[1].subMenuItems[6].name=localizedStrings.navigation.menu.students.activity;
    newItems[1].subMenuItems[8].name =
      localizedStrings.navigation.menu.students.learningAndManagement;
    newItems[2].name =
      localizedStrings.navigation.menu.facultyAndStuff.facultyAndStuff;

    newItems[2].subMenuItems[0].name =
      localizedStrings.navigation.menu.facultyAndStuff.profile;
    newItems[2].subMenuItems[1].name =
      localizedStrings.navigation.menu.facultyAndStuff.classes;
    newItems[2].subMenuItems[2].name =
      localizedStrings.navigation.menu.facultyAndStuff.enterAttendance;
    newItems[2].subMenuItems[3].name =
      localizedStrings.navigation.menu.facultyAndStuff.testsAndScore;
    newItems[2].subMenuItems[4].name =
      localizedStrings.navigation.menu.facultyAndStuff.learningAndManagement;

    newItems[3].name = localizedStrings.navigation.menu.parents.parents;
    newItems[3].subMenuItems[1].name =
      localizedStrings.navigation.menu.parents.attendance;
    newItems[3].subMenuItems[2].name =
      localizedStrings.navigation.menu.parents.grades;
    newItems[4].name = localizedStrings.navigation.menu.alumni.alumni;
    newItems[4].subMenuItems[0].name =
      localizedStrings.navigation.menu.alumni.myInfo;
    newItems[4].subMenuItems[1].name =
      localizedStrings.navigation.menu.alumni.events;
    newItems[4].subMenuItems[2].name =
      localizedStrings.navigation.menu.alumni.opportunities;
    newItems[4].subMenuItems[3].name =
      localizedStrings.navigation.menu.alumni.donations;
    newItems[5].name = localizedStrings.navigation.menu.events;
    newItems[6].name = localizedStrings.navigation.menu.courseCatalog;
    newItems[7].name = localizedStrings.navigation.menu.documents;
    newItems[8].name = localizedStrings.navigation.menu.invoices;
    newItems[9].name = localizedStrings.navigation.menu.about;
    
    setItems(newItems);
  }, [language]);

  const handelLogout = () => {
    dispatch(clearLoginData());
    window.localStorage.removeItem("x-auth-token");
    window.localStorage.removeItem("x-auth-fullname");
    window.localStorage.removeItem("x-auth-contactId");
    window.localStorage.removeItem("isUserLoggedIn");
    window.localStorage.removeItem("x-auth-email");
    window.localStorage.removeItem("x-auth-mobile");
    window.localStorage.removeItem("ses_applicantid");
    dispatch(isLoggedInUpdate(false));
    dispatch(clearErrorStatusCode());
    dispatch(clearErrorMessage());
    dispatch(clearApplicantStatus());
  };

  useEffect(() => {
    dispatch(
      getApplicantStatus(window.localStorage.getItem("x-auth-contactId")),
    );
  }, []);

  useEffect(() => {
    if (applicantStatus?.ses_applicantstatus?.ses_parentid) {
      window.localStorage.setItem(
        "parentId",
        applicantStatus.ses_applicantstatus.ses_parentid,
      );
      window.localStorage.setItem(
        "studentId",
        applicantStatus.ses_applicantstatus.ses_studentid,
      );
      
    }
  }, [applicantStatus]);

  const handleResize = () => {
    if (window.innerWidth < 1200) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };
  useEffect(() => {
    window.addEventListener("resize", handleResize);
    
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (!isObjectEmpty(errorMessage) && errorMessage !== undefined) {
      if (errorStatusCode === 401) {
        let error = {
          isError: false,
          message: "Session Expired",
          showSnackbar: true,
        };
        setError(error);
        setTimeout(() => {
          handelLogout();
        }, 1600);
      } else {
        let error = {
          isError: false,
          message: errorMessage,
          showSnackbar: true,
        };
        setError(error);
      }
    }
  }, [errorMessage, errorStatusCode]);

  useEffect(() => {
    const contactId = window.localStorage.getItem("x-auth-contactId");
    const newItems = [...Items];
    if (contactId === null) {
      newItems[0].subMenuItems[0].display = "none";
      newItems[1].display = "none";
      newItems[5].display = "none";
      newItems[6].display = "none";
      newItems[7].display = "none";
      newItems[9].display = "none";
      newItems[2].display = "none";
      newItems[3].display = "none";
      newItems[4].display = "none";
      newItems[5].display = "none";
      newItems[4].display = "none";
      newItems[0].subMenuItems[0].display = "none";
      newItems[8].display = "none";
      setItems(newItems);
    }

    if (applicantStatus.ses_applicantstatus !== undefined) {
      if (applicantStatus.ses_applicantstatus.ses_currentstudent) {
        Items[0].subMenuItems[0].display = "block";
        Items[1].display = "block";
        Items[5].display = "block";
        Items[6].display = "block";
        Items[7].display = "block";
        Items[9].display = "block";
      }
      if (applicantStatus.ses_applicantstatus.ses_currentfaculty) {
        Items[2].display = "block";
        Items[5].display = "block";
        Items[6].display = "block";
      }
      if (applicantStatus.ses_applicantstatus.ses_currentparent) {
        Items[3].display = "block";
        Items[5].display = "block";
      }

      if (applicantStatus.ses_applicantstatus.ses_currentalumnus) {
        Items[4].display = "block";
        Items[5].display = "block";
      }
      if (applicantStatus.ses_applicantstatus.ses_currentapplicant) {
        Items[0].subMenuItems[0].display = "block";
      }

      Items[8].display = "block";
      Items[0].bgColor = "red";
      Items[1].bgColor = "red";
      Items[2].bgColor = "red";
      setError({
        isError: false,
        message: errorMessage,
        showSnackbar: true,
      });
    }
  }, [
    applicantStatus.ses_applicantstatus,
    window.localStorage.getItem("x-auth-contactId"),
  ]);

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };
  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = (isMenuOpen) => {
    handleMobileMenuClose();
  };
  const callbackData = (data) => {
    if (data === "MenuBargetsClosed") {
      setMobileMoreAnchorEl(null);
    }
  };

  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      {Items.length > 0
        ? Items.map((element, index) => {
            return element.display === "none" ? null : (
              <NavMenuItem
                key={index}
                name={element.name}
                id={element.id}
                url={element.url}
                hasSubmenu={element.hasSubmenu}
                subMenuItems={element.subMenuItems}
                display={element.display}
                bgColor={element.bgColor}
                {...props}
                view={"mobile"}
                parentCallback={callbackData}
              />
            );
          })
        : null}
    </Menu>
  );

  let menuDeskstopItems = "";
  menuDeskstopItems =
    Items.length > 0
      ? Items.map((element, index) => {
          return element.display === "none" ? null : (
            <NavMenuItem
              key={index}
              name={element.name}
              id={element.id}
              url={element.url}
              hasSubmenu={element.hasSubmenu}
              subMenuItems={element.subMenuItems}
              display={element.display}
              bgColor={element.bgColor}
              view={"desktop"}
              {...props}
            />
          );
        })
      : null;

  return (
    <nav className={classes.navRoot}>
      {isMobile && (
        <>
          <div className={classes.sectionMobile}>
            <IconButton
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
          </div>
          {renderMobileMenu}
        </>
      )}
      <>
        <Backdrop />
        <div className={classes.sectionDesktop}>
          <List className={classes.listDisplay}>{menuDeskstopItems}</List>
        </div>
      </>
    </nav>
  );
};

export default withRouter(NavigationMenuItem);
